import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
class BlockTanentActivities extends Vue {

  dtDocuments: {
    title: string, icon: string,
    type: { translationKey: string, id: number },
    createdAt: string
  }[]
  get lblSetting(): { [prop: string]: string } {
    return {
      ...require('@/locales/block').default
    }
  }

  /**
   *
   */
  constructor() {
    super();
    this.dtDocuments = [
      {
        title: 'Réparation ascecenceur',
        icon: 'icon icon-quote',
        type: {
          translationKey: 'Commun',
          id: 1
        },
        createdAt: "15/10/2018"
      },
      {
        title: 'Diagnostic énergétique',
        icon: 'icon icon-quote',
        type: {
          translationKey: 'Privé',
          id: 1
        },
        createdAt: "15/10/2018"
      },
      {
        title: 'Entrelien chaudière',
        icon: 'icon icon-quote',
        type: {
          translationKey: 'Privé',
          id: 1
        },
        createdAt: "15/10/2018"
      }
    ]
  }
}

export default BlockTanentActivities;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-tenant-activities/index.ts